/// <reference path='../_all.ts' />

module navigation {
  'use strict';

  // http://plnkr.co/edit/fJwRER?p=info
  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.

  
  debounceService.$inject = ['$timeout', '$q'];
  export function debounceService($timeout :ng.ITimeoutService, $q : ng.IQService ) {

    return function (func : () => void, wait : number, immediate: boolean) {

      var timeout;
      var deferred = $q.defer();

      return function() {
        var context = this, args = arguments;
        var later = function() {
          timeout = null;
          if(!immediate) {
            deferred.resolve(func.apply(context, args));
            deferred = $q.defer();
          }
        };
        var callNow : boolean = immediate && !timeout;
        if ( timeout ) {
          $timeout.cancel(timeout);
        }
        timeout = $timeout(later, wait);
        if (callNow) {
          deferred.resolve(func.apply(context,args));
          deferred = $q.defer();
        }
        return deferred.promise;
      }


    }
  }

}